/**
 * @generated SignedSource<<a495e57caf7b66b628211e05662c5cdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleMoreOnThisListStyleArticle$data = {
  readonly styleMoreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "magazinesStyleArticleMoreOnThisContentItemContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleMoreOnThisListStyleArticle";
};
export type articleMoreOnThisListStyleArticle$key = {
  readonly " $data"?: articleMoreOnThisListStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMoreOnThisListStyleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleMoreOnThisListStyleArticle",
  "selections": [
    {
      "alias": "styleMoreOnThisArticles",
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "magazinesStyleArticleMoreOnThisContentItemContent"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "2adc20dce69f82d1832f820bd614bd20";

export default node;
